<template>
  <div class="ibox-tools">
    <a class="dropdown-toggle" data-toggle="dropdown" href="#">
      <i class="fas fa-cloud-download-alt"></i>
    </a>
    <ul class="dropdown-menu dropdown-user">
      <li>
        <span class="dropdown-item" @click="download"
          ><i class="fa fa-file-excel"></i>excel</span
        >
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    excel: {
      type: String,
    },
    fileName: {
      type: String
    },
    ext: {
      type: String,
      default: 'xls'
    }
  },
  computed: {
    exportExcel() {
      return `${this.$apiURL}/${this.excel}`;
    }
  },
  methods: {
    download() {
      this.$downloadFile(this.exportExcel, `${this.fileName}.${this.ext}`)
    }
  }
};
</script>
